import React, {FC} from 'react'
import {Modal, Button, Form, Spinner, Alert} from 'react-bootstrap'

type ModalImportHSCategoriesMappingProps = {
  show: boolean
  onClose: () => void
  onSubmit: () => void
  onFileChange: (file: File | null) => void
  isSubmitting: boolean
  errorMessage?: string | null
}

const ModalImportHSCategoriesMapping: FC<ModalImportHSCategoriesMappingProps> = ({
  show,
  onClose,
  onSubmit,
  onFileChange,
  isSubmitting,
  errorMessage,
}) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Import HS Category Mapping</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className='mb-4'>
          Upload the completed Excel file to import HS Code mappings into their respective
          categories.
        </p>

        <Form.Group controlId='hsCategoryImportFile'>
          <Form.Label>Upload File (.xlsx / .xls)</Form.Label>
          <Form.Control
            type='file'
            accept='.xlsx,.xls'
            onChange={(e) => {
              const target = e.target as HTMLInputElement
              const file = target.files?.[0] || null
              onFileChange(file)
            }}
            disabled={isSubmitting}
          />
        </Form.Group>

        {errorMessage && (
          <Alert variant='danger' className='mt-3'>
            {errorMessage}
          </Alert>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant='default' className='btn-cancel' onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button variant='primary' onClick={onSubmit} disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <Spinner animation='border' size='sm' className='me-2' />
              Importing...
            </>
          ) : (
            'Import'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalImportHSCategoriesMapping